import Environment from '@polleverywhere/core/lib/models/environment'
import URI from 'urijs'

const env = new Environment()

/**
 * @param {URI} url PE Rails API path
 * @returns {URI}
 */
export function rewriteToProxyIfNeeded (url) {
  const apiHost = env.get('api_url').host()
  const pageUri = URI('/')

  // If request is to our API and is x-domain
  if (url.host() === apiHost && pageUri.host() !== apiHost) {
    // Rewrite to use our nginx/alb proxy when available
    if (env.get('nginx_proxy_path')) {
      url = url.clone()
        .resource(env.get('nginx_proxy_path') + url.resource())
        .origin(pageUri.origin())
    }
  }

  return url
}

/**
 * @returns {URI}
 */
export function apiUrlFor (path, query) {
  return env.get('api_url').pathname(path).query(query || {})
}
